import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FacturasTabs from '../components/FacturasTabs';
import TableReceivedInvoiceComponent from '../components/TableReceivedInvoiceComponent';
import { validateSession } from '../utils/functions';

// Facturas → Recibidas: los comprobantes que los proveedores emitieron a nuestro RUT.
class ReceivedInvoicesPage extends Component {

    constructor() {
        super();
        this.state = { checked: false, role: 0 };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={17} role={this.state.role}/>
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4" style={{ paddingBottom: '80px' }}>
                            <HeaderComponent title="Compras" subtitle="Facturas recibidas"/>
                            <FacturasTabs active="/receivedInvoices" />
                            <TableReceivedInvoiceComponent role={this.state.role}/>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default ReceivedInvoicesPage;
